/* Kuji Explainer-Video: Overlay öffnen/schließen. Ton startet, weil das Abspielen aus dem Tipp kommt. */
(function () {
  'use strict';
  function init(root) {
    if (root._kjxrExplain) return;
    var btn = root.querySelector('[data-kjxr-explain]');
    var modal = root.querySelector('[data-kjxr-vmodal]');
    if (!btn || !modal) return;
    root._kjxrExplain = true;
    var video = modal.querySelector('video');
    var closeBtn = modal.querySelector('.kjxr-vclose');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('show');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (video) {
        try { video.currentTime = 0; } catch (e) {}
        video.muted = false;
        var p = video.play();
        if (p && p.catch) p.catch(function () { video.muted = true; video.play().catch(function () {}); });
      }
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function close() {
      if (!modal.classList.contains('show')) return;
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (video) video.pause();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    btn.addEventListener('click', open);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-kjxr-vclose]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function boot() { document.querySelectorAll('.kjxr[data-section-id]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
